
import React, { useEffect, useState } from 'react';
import '../../styles/vendeurs/NotificationVendeur.css';

import { useNavigate } from 'react-router-dom';
import { fetchNotifications, marquerNotificationsCommeLues } from '../../services/notificationService';

function NotificationVendeur({ vendeurId }) {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

 useEffect(() => {
  const charger = async () => {
    try {
      const data = await fetchNotifications(vendeurId);
      setNotifications(data);

      // ✅ Marquer comme lues
      await marquerNotificationsCommeLues(vendeurId);
    } catch (err) {
      console.error("Erreur chargement notifications :", err);
    }
  };

  if (vendeurId) {
    charger();
  }
}, [vendeurId]);

const handleClick = (notif) => {
  if (notif.commande_id) {
    localStorage.setItem('commandeNotifiée', notif.commande_id);
    navigate('/vendeur/commandes');
  }
};

  return (
    <div className="notifications-container">
      {notifications.length === 0 ? (
        <p>Aucune notification</p>
      ) : (
        <ul className="notif-list-green">
          {notifications.map((notif) => (
            <li
              key={notif.id}
              className={`notif-item-green ${notif.lu ? 'lu' : 'non-lu'}`}
              onClick={() => handleClick(notif)}
            >
              <div className="notif-text-green">
                {notif.message}
                <br />
                <small>{new Date(notif.date).toLocaleString()}</small>
              </div>
              {!notif.lu && <span className="notif-dot-green" />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default NotificationVendeur;
